import paymentConfigTypes from './types';

// Fetch all configurations
export const fetchPaymentConfig = () => ({
  type: paymentConfigTypes.FETCH_PAYMENT_CONFIG_REQUEST,
});
export const fetchPaymentConfigSuccess = (payload) => ({
  type: paymentConfigTypes.FETCH_PAYMENT_CONFIG_SUCCESS,
  payload,
});
export const fetchPaymentConfigFailure = (error) => ({
  type: paymentConfigTypes.FETCH_PAYMENT_CONFIG_FAILURE,
  error,
});

// Fetch paystack configurations
export const fetchPaystackConfig = (id) => ({
  type: paymentConfigTypes.FETCH_PAYSTACK_CONFIG_REQUEST,
  payload: id,
});
export const fetchPaystackConfigSuccess = (payload) => ({
  type: paymentConfigTypes.FETCH_PAYSTACK_CONFIG_SUCCESS,
  payload,
});
export const fetchPaystackConfigFailure = (error) => ({
  type: paymentConfigTypes.FETCH_PAYSTACK_CONFIG_FAILURE,
  error,
});

// Fetch remita configurations
export const fetchRemitaConfig = (id) => ({
  type: paymentConfigTypes.FETCH_REMITA_CONFIG_REQUEST,
  payload: id,
});
export const fetchRemitaConfigSuccess = (payload) => ({
  type: paymentConfigTypes.FETCH_REMITA_CONFIG_SUCCESS,
  payload,
});
export const fetchRemitaConfigFailure = (error) => ({
  type: paymentConfigTypes.FETCH_REMITA_CONFIG_FAILURE,
  error,
});

// Fetch nabroll configurations
export const fetchNabrollConfig = (id) => ({
  type: paymentConfigTypes.FETCH_NABROLL_CONFIG_REQUEST,
  payload: id,
});
export const fetchNabrollConfigSuccess = (payload) => ({
  type: paymentConfigTypes.FETCH_NABROLL_CONFIG_SUCCESS,
  payload,
});
export const fetchNabrollConfigFailure = (error) => ({
  type: paymentConfigTypes.FETCH_NABROLL_CONFIG_FAILURE,
  error,
});
// Fetch remita configurations
export const fetchInterswitchConfig = (id) => ({
  type: paymentConfigTypes.FETCH_INTERSWITCH_CONFIG_REQUEST,
  payload: id,
});
export const fetchInterswitchConfigSuccess = (payload) => ({
  type: paymentConfigTypes.FETCH_INTERSWITCH_CONFIG_SUCCESS,
  payload,
});
export const fetchInterswitchConfigFailure = (error) => ({
  type: paymentConfigTypes.FETCH_INTERSWITCH_CONFIG_FAILURE,
  error,
});

// import payment configurations
export const importBankAccounts = (id, cb) => ({
  type: paymentConfigTypes.IMPORT_PAYMENT_CONFIG_REQUEST,
  payload: { id, cb },
});
export const importBankAccountsSuccess = () => ({
  type: paymentConfigTypes.IMPORT_PAYMENT_CONFIG_SUCCESS,
});
export const importBankAccountsFailure = (error) => ({
  type: paymentConfigTypes.IMPORT_PAYMENT_CONFIG_FAILURE,
  error,
});

// delete payment configurations
export const deletePaymentConfig = (paymentConfig, cb) => ({
  type: paymentConfigTypes.DELETE_PAYMENT_CONFIG_REQUEST,
  payload: { paymentConfig, cb },
});
export const deleteRemitaPaymentConfigSuccess = () => ({
  type: paymentConfigTypes.DELETE_REMITA_PAYMENT_CONFIG_SUCCESS,
});
export const deletePaystackPaymentConfigSuccess = () => ({
  type: paymentConfigTypes.DELETE_PAYSTACK_PAYMENT_CONFIG_SUCCESS,
});
export const deleteInterswitchPaymentConfigSuccess = () => ({
  type: paymentConfigTypes.DELETE_INTERSWITCH_PAYMENT_CONFIG_SUCCESS,
});
export const deletePaymentConfigFailure = (error) => ({
  type: paymentConfigTypes.DELETE_PAYMENT_CONFIG_FAILURE,
  error,
});

// update payment configurations
export const updatePaymentConfig = (paymentConfig, cb) => ({
  type: paymentConfigTypes.UPDATE_PAYMENT_CONFIG_REQUEST,
  payload: { paymentConfig, cb },
});
export const updatePaymentConfigSuccess = () => ({
  type: paymentConfigTypes.UPDATE_PAYMENT_CONFIG_SUCCESS,
});
export const updatePaymentConfigFailure = (error) => ({
  type: paymentConfigTypes.UPDATE_PAYMENT_CONFIG_FAILURE,
  error,
});

// update payment configurations platform charges

export const updatePlatformCharge = (
  institutionInfo,
  newPlatformChargeStatus,
  cb
) => ({
  type: paymentConfigTypes.UPDATE_PLATFORM_CHARGE_REQUEST,
  payload: { institutionInfo, newPlatformChargeStatus, cb },
});

